"use client";

import Spinner from "@/components/spinner";
import EmptyResult from "./empty-result";
import style from "./style.module.scss";
import SearchStationItem from "./SearchStationItem";
import { ISearchStationItem } from "@/interfaces/Map";
import { GENERAL } from "@/constants";

type Props = {
  stations: ISearchStationItem[];
  onSelectStation: (station: ISearchStationItem) => void;
  loading: boolean;
};

const SearchStationItemsContainer = ({
  stations,
  onSelectStation,
  loading,
}: Props) => {
  return (
    <div className={style.searchResultBoard}>
      {loading ? (
        <div className={style.loadingSkeletons}>
          {[...Array(GENERAL.SKELETON_COUNT)].map((_, index) => (
            <div key={index} className={style.loadingSkeleton} />
          ))}
        </div>
      ) : (
        <div className={style.searchStationItemsContainer}>
          {stations.length > 0 ? (
            stations?.map((station) => (
              <SearchStationItem
                key={station?.icao_code}
                station={station}
                onSelect={onSelectStation}
              />
            ))
          ) : (
            <EmptyResult />
          )}
        </div>
      )}
    </div>
  );
};

export default SearchStationItemsContainer;
